import type { ReactNode } from 'react';
import { CalendarContext, type CalendarContextValue } from './calendar-context';

/** Shares the shell's calendar state (useCalendarState) with the rail, the page and the dialogs. */
export function CalendarProvider({ value, children }: { value: CalendarContextValue; children: ReactNode }) {
  return <CalendarContext.Provider value={value}>{children}</CalendarContext.Provider>;
}
